import React from 'react';
import { EngagementSection, UsageSection } from './usage';
import { TransactionSummarySection } from '../../common/analytics';
import { applyDashboardDonutColors } from '../dashboard.constants';
import styles from './styles/usage-data.module.scss';

// UI copy only (titles/subtitles). All numeric values come from the API.
const COPY = {
    engagementSummary: { title: 'Engagement Summary', subtitle: 'Enrolled, Engaged & Active' },
    userSessions: { title: 'User Sessions', subtitle: 'Sessions Over Time' },
    advanceSummary: { title: 'Advance Summary', subtitle: 'Advance Activity Over Time' },
    advancesByType: { title: 'Advances by Type', subtitle: 'Instant vs Standard', totalLabel: 'Advances' },
};

function UsageData({
    data,
    loading = false,
    engagementSummaryMetrics,
    transactionSummary,
    cohort,
    sessions,
    onEngagementSummaryFrequencyChange,
    onTransactionSummaryTableChange,
}) {
    const d = data || {};
    const engagementKpis = d.engagementKpis || [];
    const usageKpis = d.usageKpis || [];
    const usageBottomKpis = d.usageBottomKpis || [];
    const engagementSummary = { ...COPY.engagementSummary, series: [], data: {}, ...(d.engagementSummary || {}) };
    const engagementSummaryData = {
        ...engagementSummary,
        data: engagementSummaryMetrics?.data || {},
    };
    const userSessions = { ...COPY.userSessions, series: [], data: {}, ...(d.userSessions || {}) };
    const advanceSummary = { ...COPY.advanceSummary, series: [], data: {}, ...(d.advanceSummary || {}) };
    const advancesByType = {
        ...COPY.advancesByType,
        total: '0',
        segments: [],
        ...(d.advancesByType || {}),
    };
    advancesByType.segments = applyDashboardDonutColors(advancesByType.segments, 'advancesByType');
    const transactionSummaryRows = transactionSummary?.rows || [];
    const transactionSummaryPagination = transactionSummary?.pageInfo || null;

    return (
        <div className={styles.usageContainer}>
            <EngagementSection
                kpis={engagementKpis}
                engagementSummary={engagementSummaryData}
                engagementSummaryMetrics={engagementSummaryMetrics}
                onEngagementSummaryFrequencyChange={onEngagementSummaryFrequencyChange}
                userSessions={userSessions}
                cohort={cohort}
                loading={loading}
            />
            <UsageSection
                kpis={usageKpis}
                advanceSummary={advanceSummary}
                advancesByType={advancesByType}
                bottomKpis={usageBottomKpis}
                sessions={sessions}
                loading={loading}
            />
            <TransactionSummarySection
                rows={transactionSummaryRows}
                loading={loading || transactionSummary?.loading}
                pageInfo={transactionSummaryPagination}
                onTableChange={onTransactionSummaryTableChange}
            />
        </div>
    );
}

export default UsageData;
